{
  "footer": {
    "logoPath": "/assets/images/wmdi_logo.svg",
    "copyrightText": {
      "primary": "WebMD Ignite. All Rights Reserved. Third Party materials included herein protected under copyright law.",
      "secondary": "Use of this website and any information contained herein is governed by contract with WebMD Ignite."
    },
    "altText": "Admin Portal"
  },
  "header": {
    "logoPath": "/assets/images/wmdi_logo.svg",
    "mediaHeaderLogoPath": "/assets/images/wmdi_logo_stacked.svg",
    "altText": "Administration",
    "appTitle": "Administration",
    "profileRedirectData": {
      "logout": "Log out"
    }
  },
  "endpoints": {
    "appEndpoints": {
      "userScopes": "/auth/me",
      "legacyFederatedDomain": "/auth/clients/legacy-federated-domains",
      "clientList": "/auth/me/clients",
      "sessionRefresh": "/auth/tokens/refresh"
    }
  },
  "auth": {
    "retryCount": 1,
    "delay": 2000
  },
  "errorMessageHandler": {
    "accessDenied": {
      "iconPath": "/assets/images/lock.svg",
      "title": "Access denied",
      "description": "You don't have permissions to access this page.<br> Please contact your system administrator to get permissions.",
      "statusCode": "403",
      "loaderStatus": false
    },
    "defaultMessage": {
      "iconPath": "/assets/images/circle.svg",
      "title": "Hmm, something's not right.",
      "description": "Sorry, looks like there's an issue with your account permissions.<br> Please contact you system administrator.",
      "statusCode": "",
      "loaderStatus": false
    }
  },
  "cacheFactoryConfig": {
    "cacheMaxAge": 3600000,
    "cacheFlushInterval": 3600000
  }
}
